import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Components
import Login from "../../components/Login";
import ForgotPassword from "../../components/ForgotPassword";
import OTPVarification from "../../components/OTPVarification";
import SetNewPassword from "../../components/SetNewPassword";

//Redux

import * as sessionActions from "../../redux/authentication/actions";

class Auth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
    };
  }

  handleLoginUser = (data) => {
    this.props.actions.loginUser(data);
  };

  handleForgotPassword = (data) => {
    let state = this.state;
    state.username = data;
    this.setState({ ...state });
    this.props.actions.forgotPassword(data);
  };

  handleSetNewPassword = (item) => {
    let state = this.state;
    let data = {
      username: state.username,
      otp: item.otp,
      password: item.password,
    };
    this.props.actions.setNewPassword(data);
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "login":
        return (
          <Login
            loginUserStatus={this.props.loginUserStatus}
            handleLoginUser={this.handleLoginUser}
            elements={this.props.elements}
          />
        );

      case "forget-password":
        return (
          <ForgotPassword
            forgetPasswordStatus={this.props.forgetPasswordStatus}
            handleForgotPassword={this.handleForgotPassword}
            elements={this.props.elements}
          />
        );

      case "otp-verify":
        return (
          <OTPVarification
            handleSetNewPassword={this.handleSetNewPassword}
            username={this.state.username}
            setNewPasswordStatus={this.props.setNewPasswordStatus}
            elements={this.props.elements}
          />
        );

      case "set-new-password":
        return <SetNewPassword />;

      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    loginUserStatus: state.Auth.loginUserStatus,
    userId: state.Auth.userId,
    forgetPasswordStatus: state.Auth.forgetPasswordStatus,
    setNewPasswordStatus: state.Auth.setNewPasswordStatus,
    elements: state.Elements.elements,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Auth));
